import React from 'react';
import {
  ConfigContent,
  ExternalDependenciesContent,
  InfoContent,
} from '@backstage/plugin-devtools';
import { DevToolsLayout } from '@backstage/plugin-devtools';

export const DevToolsPage = () => {
  return (
    <DevToolsLayout
      title="DevTools"
      subtitle="Developer-focused utilities tied to specific entities. Allows to pull
          status from Jenkins, GitHub Actions, GitLab CI, etc. Shows recent
          builds, deploys, statuses"
    >
      <DevToolsLayout.Route path="info" title="Info">
        <InfoContent />
      </DevToolsLayout.Route>
      <DevToolsLayout.Route path="config" title="Config">
        <ConfigContent />
      </DevToolsLayout.Route>
      <DevToolsLayout.Route
        path="external-dependencies"
        title="External Dependencies"
      >
        <ExternalDependenciesContent />
      </DevToolsLayout.Route>
    </DevToolsLayout>
  );
};

export const customDevToolsPage = <DevToolsPage />;
